import { BoxInfo, MnemoLoading, Title } from "components/misc";
import { MTable } from "components/table";
import { ROUTES } from "const";
import { Container, Col, Row, Button } from "design-react-kit";
import { dateHelper, networkErrorHelper } from "libs";
import { newsletterService } from "libs/api/newsletterService";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class NewsletterEmails extends Component {
  state = {
    loading: true,
    rndKey: 0,
    payload: [],
    currentPayload: [],
  };

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "senderEmail",
        Header: "Email mittente",
        accessor: "senderEmail",
      },
      {
        id: "senderName",
        Header: "Nome mittente",
        accessor: "senderName",
      },
      {
        id: "subject",
        Header: "Oggetto",
        accessor: "subject",
      },
      {
        id: "dateCreation",
        Header: "Data creazione",
        accessor: (row) => {
          return row.createdAt ? dateHelper.toITDateTime(row.createdAt) : "";
        },
      },
      {
        id: "note",
        Header: "Note",
        accessor: "note",
      },
      {
        id: "status",
        Header: "Stato",
        accessor: (row) => {
          const statusMap = {
            created: "Creato",
            queued: "In Coda",
            inProgress: "In Lavorazione",
            suspended: "Sospeso",
            error: "Errore",
            end: "Terminato",
          };

          return statusMap[row.status];
        },
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href = ROUTES.NEWSLETTER_EMAIL_DETAIL + "/" + value;
        },
      },
    ],
  };

  //--- ---

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote() {
    this.setState({ loading: true });

    newsletterService
      .getNewsletterEmails()
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.emails).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          currentPayload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            currentPayload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
          });
        }
      });
  }

  render() {
    const { loading, currentPayload, rndKey } = this.state;

    return (
      <>
        <Title>Invii email newsletter</Title>

        <hr />
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <Container>
              <Row className="my-2 align-items-center">
                <Col>
                  <Button
                    className="mx-1 float-right"
                    color="primary bg-dark"
                    onClick={() => this.props.history.push(ROUTES.NEWSLETTER_EMAIL_FORM)}
                    disabled={loading}
                  >
                    Nuovo invio
                  </Button>
                </Col>
              </Row>

              <MTable key={rndKey} tableData={currentPayload} tableConfig={this.tableConfig} />
            </Container>
          )}

          {currentPayload.length === 0 && (
            <BoxInfo key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare.</div>
            </BoxInfo>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(NewsletterEmails);
